export default __webpack_public_path__ + "edd311588712a96bbf435fad264fff62.woff";